import { useState, useEffect } from 'react';
import { calculateRemainingTime, calculateDailyDealsTimer } from '../utils';
import { CAMPAIGN_CONFIG } from '../constants';

/**
 * Custom hook to manage campaign and daily deals timers
 */
export const useTimers = () => {
  const [remainingTime, setRemainingTime] = useState(
    calculateRemainingTime(CAMPAIGN_CONFIG.TARGET_DATE)
  );
  const [dailyDealsTimer, setDailyDealsTimer] = useState(
    calculateDailyDealsTimer()
  );
  const [showTimer, setShowTimer] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedRemainingTime = calculateRemainingTime(CAMPAIGN_CONFIG.TARGET_DATE);
      setRemainingTime(updatedRemainingTime);
      
      if (updatedRemainingTime.days <= 2 && !showTimer) {
        setShowTimer(true);
      }
      
      const updatedDailyDealsTimer = calculateDailyDealsTimer();
      setDailyDealsTimer(updatedDailyDealsTimer);
    }, 1000);

    return () => clearInterval(timer);
  }, [showTimer]);

  return { remainingTime, dailyDealsTimer, showTimer };
};
